import React, { Component, Fragment } from 'react';
import { addField } from 'ra-core';
import Map from './map';
import { getMarkers, getPosition } from './utils';
import * as Constants from '../constants'
import CircularProgress from '@material-ui/core/CircularProgress';

export default class GMap extends Component {
  constructor(props) {
    super(props);
    const { defaultZoom, defaultCenter } = this.props;

    this.state = {
      center: defaultCenter || { lat: 31.880012, lng: 35.01361 },
      zoom: defaultZoom || 15,
      image: "",
      bounds: [],
      isImageLoaded: false,
    };

    this.putMarker = ({ markerPos, input, multipleMarkers }) => {
      const currentValue = getMarkers(input);
      const fixedMarkerPos = {
        lat: parseFloat(markerPos.lat.toFixed(12)),
        lng: parseFloat(markerPos.lng.toFixed(12))
      }
      if (multipleMarkers) {
        if (currentValue && currentValue !== null) {
          return input.onChange([...currentValue, fixedMarkerPos]);
        }
        return input.onChange([fixedMarkerPos]);
      }
      return input.onChange(fixedMarkerPos);
    };

    
    this.getTrack = () => {
      const { formData } = this.props;
      console.log('Fetching track data for track ID:', formData.track);
        return fetch(`${Constants.siteUrl}/tracks/${formData.track}/`, { method: 'GET' })
        .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        })
        .then((track) => {
          console.log('Track data received:', track);
          console.log('Track image:', track.image);
          console.log('Track image_bounds:', track.image_bounds);
          return track;
        })
        .catch((e) => {
          console.error('Error fetching track data:', e);
            return null;
        });
    }

    this.setCenter = markerPos => this.setState({ center: markerPos });

    this.putMarkerFromSearch = ({
      markerPos, input, justShow, multipleMarkers,
    }) => {
      this.putMarker({ markerPos, input, multipleMarkers });
      this.setCenter(markerPos);
    };

    this.deleteMarker = ({ markerPos, input, multipleMarkers }) => {
      const currentValue = getMarkers(input);
      let newValue;
      if (multipleMarkers) {
        newValue = currentValue.filter(mrk => mrk.lat !== markerPos.lat
          && mrk.lng !== markerPos.lng);
        if (!newValue.length) {
          newValue = null;
        }
      } else { newValue = null; }
      input.onChange(newValue);
    };
  }

  componentDidMount() {
    const { input, formData } = this.props;
    const markers = getMarkers(input);
    if (markers) {
      if (markers instanceof Array) {
        this.setState({ center: markers[markers.length - 1] });
      } else {
        this.setState({ center: markers });
      }
    }
    if (formData.track) {
      this.getTrack().then((track) => 
      {
        if (track && track.image && track.image_bounds) {
          console.log('Setting up map with image:', track.image);
          const img = new Image();
          img.src = track.image;
          img.onload = () => {
            console.log('Image loaded successfully');
            this.setState({isImageLoaded: true});
          }
          img.onerror = () => {
            console.error('Failed to load image:', track.image);
          }
          const bounds = track.image_bounds;
          // Calculate center point from bounds
          const centerLat = (bounds[0][0] + bounds[1][0]) / 2;
          const centerLng = (bounds[0][1] + bounds[1][1]) / 2;
          this.setState({image: track.image, 
            bounds, center: {lat: centerLat, lng: centerLng}})
        } else {
          console.warn('Track data missing image or bounds:', track);
        }
      });
    }
  }

  async componentDidUpdate(prevProps) {
    if(this.props.formData.track !== undefined && this.props.formData.track !== prevProps.formData.track) {
      this.setState({isImageLoaded: false});
      this.getTrack().then((track) => 
        {
          if (track && track.image && track.image_bounds) {
            console.log('Updating map with new track image:', track.image);
            const bounds = track.image_bounds;
            // Calculate center point from bounds
            const centerLat = (bounds[0][0] + bounds[1][0]) / 2;
            const centerLng = (bounds[0][1] + bounds[1][1]) / 2;
            this.setState({image: track.image, 
              bounds, center: {lat: centerLat, lng: centerLng}
            });
              const img = new Image();
              img.src = track.image;
              img.onload = () => {
                console.log('Updated image loaded successfully');
                this.setState({isImageLoaded: true});
              }
              img.onerror = () => {
                console.error('Failed to load updated image:', track.image);
              }
          } else {
            console.warn('Updated track data missing image or bounds:', track);
          }
        });
      }
    }

  render() {
    const {
      input,
      multipleMarkers,
    } = this.props;
    const childrenProps = {
      input,
      markers: getMarkers(input),
      multipleMarkers,
      groundOverlayOpacity: this.props.formData.opacity,
      loadingElement: <div style={{ height: '100%' }} />,
      containerElement: <div style={{ height: '80vh' }} />,
      googleMapURL: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCTF0Xc4Q_2Kt85EVdtE_1dsJ3vTCanjUs&v=3.exp&libraries=geometry,drawing,places`,
      
    };

    const { center, zoom, image, bounds, isImageLoaded } = this.state;
    console.log(isImageLoaded)
    return (
      <Fragment>
        <div style={{ position: 'relative' }}>
          {
            image === "" ?
            <span></span> :
            isImageLoaded ?
          <Map
            mapElement={<div style={{ height: '100%' }} />}
            center={center}
            image={image}
            bounds={bounds}
            defaultZoom={zoom}
            onMapClick={e => this.putMarker({
              input,
              multipleMarkers,
              markerPos: getPosition(e),
            })}
            onMarkerClick={e => this.deleteMarker({
              input,
              multipleMarkers,
              markerPos: getPosition(e),
            })}
            {...childrenProps}
          /> : 
          <div style={{textAlign: "center", alignItems: "center"}}>
            <CircularProgress />
          </div>
  }
        </div>
      </Fragment>
    );
  }
}

export const GMapInput = addField(GMap);
export const GMapField = ({ record, source, ...props }) => (
  <GMap
    {...props}
    justShow
    input={{ value: record[source] }}
    searchable={false}
  />
);